module.exports = __webpack_public_path__ + "assets/img/img-map-tokyo.823f7f64.svg";